export default function Hero() {
  const stats = [
    { value: '10万+', label: '海量片库' },
    { value: '1080P', label: '蓝光画质' },
    { value: '每日更新', label: '50+ 部影片' },
  ];

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden scroll-mt-16"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20composition%20with%20golden%20light%20rays%20streaming%20through%20film%20elements%2C%20soft%20bokeh%20background%2C%20rich%20amber%20and%20deep%20crimson%20tones%2C%20elegant%20theatrical%20atmosphere%2C%20modern%20minimalist%20aesthetic%2C%20no%20text%2C%20high%20detail%2C%20dreamy%20mood&width=1600&height=900&seq=hero-cinema-01&orientation=landscape"
          alt="草民影院 - 高清影视平台主视觉"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/15 text-accent-400 text-sm font-medium tracking-wide mb-5">
              高清影视平台
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-white leading-tight mb-4">
              草民影院 - 您的专属高清观影平台
            </h1>

            <p className="text-lg md:text-xl text-white/80 font-medium mb-6">
              1080P蓝光画质 · 高清不卡 · 流畅不缓冲 · 即点即看
            </p>

            <p className="text-sm md:text-base text-white/65 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              草民影院汇集海量高清电影与超清电视剧资源，覆盖动作、喜剧、悬疑、科幻等全类型内容。
              依托高速分发网络，提供<strong className="text-white/85">1080P蓝光画质</strong>在线观影体验，
              高清不卡顿、流畅不缓冲、即点即看。每日持续更新热门影片与经典佳作，
              打造属于每一位影迷的掌上私人影院。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading text-primary-400">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-white/55 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-all whitespace-nowrap cursor-pointer text-center text-sm"
              >
                开始观影
              </a>
              <a
                href="#about"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3 border border-white/30 hover:border-white/60 text-white hover:text-white rounded-lg transition-all whitespace-nowrap cursor-pointer text-center text-sm font-medium"
              >
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-black/30">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20film%20strip%20floating%20in%20warm%20golden%20glow%2C%20abstract%20movie%20elements%20with%20soft%20lens%20flare%2C%20rich%20amber%20and%20burgundy%20gradient%20background%2C%20elegant%20theatrical%20composition%2C%20artistic%20minimal%20style%2C%20no%20text%2C%20dreamy%20cinematic%20mood%2C%20high%20detail&width=1200&height=800&seq=hero-visual-02&orientation=landscape"
                alt="草民影院观影体验"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-white/10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}